// ActivityListTable.js
import React, { useState, useEffect, useRef } from 'react';
import { onValue, ref } from 'firebase/database';
import { db } from '../../firebase';
import Sidebar from '../../components/sidebar/Sidebar';
import './ActivityListTable.css';

const ActivityListTable = () => {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortDirection, setSortDirection] = useState('asc');
    const ITEMS_PER_PAGE = 10;  // Number of items per page
    const tableWrapperRef = useRef(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const dbRef = ref(db, 'ActivityLogs/'); // Assume data is stored under 'data' node
                onValue(dbRef, (snapshot) => {
                    const firebaseData = snapshot.val();
                    const dataList = [];
                    for (let id in firebaseData) {
                        dataList.push({ id, ...firebaseData[id] });
                    }
                    // Sort the data by timestamp in descending order
                    // dataList.sort((a, b) => new Date(b.timestamp).toLocaleString() - new Date(a.timestamp).toLocaleString());
                    setData(dataList.reverse());
                });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    // Handle sorting
    const handleSort = () => {
        const sortedData = [...data].sort((a, b) => {
            return sortDirection === 'asc'
                ? a.name.localeCompare(b.name)
                : b.name.localeCompare(a.name);
        });

        setData(sortedData);
        setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    };

    const loadMoreData = () => {
        setCurrentPage(prevPage => prevPage + 1);
    };
    useEffect(() => {
        const handleScroll = () => {
            const { scrollTop, clientHeight, scrollHeight } = tableWrapperRef.current;
            if (scrollTop + clientHeight >= scrollHeight) {
                loadMoreData();
            }
        };
        const wrapperRef = tableWrapperRef.current;

        if (wrapperRef) {
            wrapperRef.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (wrapperRef) {
                wrapperRef.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    const totalItemsDisplayed = currentPage * ITEMS_PER_PAGE;
    const currentItems = data.slice(0, currentPage * ITEMS_PER_PAGE);

    return (
        <div className="list">
            <Sidebar />
            <div className="listContainer">
                <div className="table-wrapper" ref={tableWrapperRef}>
                    <table className="styled-table mt-3">
                        <thead>
                            <tr>
                                <th>Timestamp</th>
                                <th onClick={handleSort}>
                                    Name
                                    {sortDirection === 'asc' ? ' (↓)' : ' (↑)'}
                                </th>

                                <th>Email</th>
                                <th>Action</th>
                                <th>Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((item) => (
                                <tr key={item.id}>
                                    {/* <td>{item.id}</td> */}
                                    <td>{new Date(item.timestamp).toLocaleString()}</td>
                                    <td>{item.name}</td>
                                    <td>{item.email}</td>
                                    <td>{item.action}</td>
                                    <td>{item.details}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {data.length > totalItemsDisplayed && (
                    <div className="load-more">
                        <button onClick={loadMoreData}>Load More</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ActivityListTable;
